import { Octagon, Timer, TriangleAlert } from 'lucide-react';
import type { Jump } from '@wht-xc-utils/shared/domain';

export function JumpIndicators({
  jump,
  includeDifficulty = true,
}: {
  jump: Pick<Jump, 'difficultToJudge' | 'stoppingPoint' | 'timingPoint'>;
  includeDifficulty?: boolean;
}) {
  if (!jump.difficultToJudge && !jump.stoppingPoint && !jump.timingPoint) return null;
  return (
    <span className="jump-indicators">
      {jump.difficultToJudge && includeDifficulty ? (
        <span
          className="jump-indicator-tooltip"
          title="Difficult to judge"
          aria-label="Difficult to judge"
        >
          <TriangleAlert aria-hidden="true" className="jump-indicator difficult" />
        </span>
      ) : null}
      {jump.stoppingPoint ? (
        <span className="jump-indicator-tooltip" title="Stopping point" aria-label="Stopping point">
          <Octagon aria-hidden="true" className="jump-indicator stopping" />
        </span>
      ) : null}
      {jump.timingPoint ? (
        <span className="jump-indicator-tooltip" title="Timing point" aria-label="Timing point">
          <Timer aria-hidden="true" className="jump-indicator timing" />
        </span>
      ) : null}
    </span>
  );
}
